import Campaign from './campaign';

export default {
  Campaign,
};
